import { render, staticRenderFns } from "./ForestMap.vue?vue&type=template&id=5af34263&scoped=true"
import script from "./ForestMap.vue?vue&type=script&lang=js"
export * from "./ForestMap.vue?vue&type=script&lang=js"
import style0 from "./ForestMap.vue?vue&type=style&index=0&id=5af34263&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af34263",
  null
  
)

export default component.exports